// extracted by mini-css-extract-plugin
export default {"ellipsis":"JRq5CtAH9pZO6IwlU3CR","wrapper":"bEqjSSbegrO3LNDyCQ1K","column":"GezCKtyIlizI8VhcztWv","selected":"qTa76JRbUypGCFGIsNxm","spin":"CD7i4mUjTcWuamRgbEMw"};